<template>
    <div class="card p-3 h-100" v-if="activityLogs">
      <h2>Activity timeline</h2>
      <hr class="mt-3 mb-3">
      <div class="row" style="overflow:auto">
        <div class="col">
           <div class="row activity-event ml-2" v-for="(log,index) in activityLogs" :key="'log' + index">
              <div class="">
                <div v-if="log.eventType === 'supply-or-demand-change' || log.eventType === 'pickup-time-change'" class="activity-icon bg-warning"><i class="fa fa-info"></i></div>
                <div v-if="log.eventType === 'cancelled-all-drops-for-today' || log.eventType === 'no-longer-available-on-day'" class="activity-icon bg-danger"><i class="fa fa-times"></i></div>
                <div v-if="log.eventType === 'available-on-new-day'" class="activity-icon bg-success"><i class="fa fa-check"></i></div>
              </div>
              <div class="col">
                <h3>{{ eventTitle(log.eventType) }} <small v-if="log.retailer"> @ {{ log.retailer.name }}</small></h3>
                <p>{{ eventDescription(log.eventType, log.eventDescription) }}</p>
                <small>{{ timeSinceEventHappened(log.eventDate) }}</small>
              </div>
            </div>
          </div>  
        </div>
      </div>
     
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'activity-card',
    components: {
      
    },

    props:[
      'activityLogs'
    ],

    data() {
      return {
       
      };
    },

    computed:{
      
    },

    methods: {
      /**
       * How long since event was logged
       */
      timeSinceEventHappened(date){
        return moment(date).fromNow();
      },

      /**
       * Get the correct event title
       */
      eventTitle(eventType){
        let title = '';
        switch(eventType){
          case 'supply-or-demand-change':
            title = 'Quantity changed';
            break;
          case 'pickup-time-change':
            title = 'Pickup time changed';
            break;
          case 'cancelled-all-drops-for-today':
            title = 'Cancelled for the day';
            break;
          case 'no-longer-available-on-day':
            title = 'No longer available on day';
            break;
          case 'available-on-new-day':
            title = 'New available day';
            break;
        }
        return title;
      },

      /**
       * Get the correct event description
       */
      eventDescription(eventType, eventDescription){
        let description = eventDescription;
        switch(eventType){
          case 'cancelled-all-drops-for-today':
            description = 'Drops will restart on the next available day';
            break;
        }
        return description;
      }
    },

    watch:{
        
    }
  }
</script>

<style lang="scss" scoped>
  $icon-size:36px;

  .card{
    max-height: 685px;
  }

  .activity-icon{
    border-radius:$icon-size/2;
    background-color:red; 
    width:$icon-size; 
    height:$icon-size;
    z-index:1;
    position: relative;
    i{
      width: $icon-size;
      height: $icon-size;
      line-height: $icon-size;
      text-align: center;
      color: white;
      
    }
  }

  .activity-event{
    position: relative;
    padding-bottom: 1rem;
    overflow: hidden;
    h3{
      margin-bottom:0;
    }
    p{
      margin-bottom: 0;
    }
    
    &:not(:last-child):before{
      content: ' ';
      width: 1px;
      height: 100%;
      position: absolute;
      z-index:0;
      background: #eee;
      left: $icon-size/2;
    }
  }
</style>